import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GlassPanel from "@/components/GlassPanel";
import PasswordInput from "@/components/PasswordInput";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(identifier, password);
      toast.success("SESSION INITIALIZED");
      navigate("/my-gps");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6 py-16" data-testid="login-page">
      <GlassPanel className="p-10 w-full max-w-md" scanline>
        <img
          src="https://customer-assets.emergentagent.com/job_gps-arena-1/artifacts/ys68irlq_GPS%20Logo%20AI-09.png"
          alt="GPS"
          className="h-12 w-12 logo-glow mb-4"
        />
        <div className="gps-tag mb-3">SECURE ACCESS</div>
        <h1 className="gps-heading text-3xl">LOGIN</h1>
        <p className="text-mute text-sm mt-2">Re-enter the system.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="gps-label">EMAIL OR PHONE</label>
            <input
              type="text"
              className="gps-input"
              required
              autoComplete="username"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="athlete@gps.io OR +15551234567"
              data-testid="login-identifier"
            />
          </div>
          <div>
            <label className="gps-label">PASSWORD</label>
            <PasswordInput
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              testIdToggle="login-password-toggle"
            />
          </div>
          <button type="submit" disabled={busy} className="gps-btn w-full" data-testid="login-submit">
            {busy ? "AUTHENTICATING..." : "INITIATE"}
          </button>
          <div className="text-right pt-1">
            <Link
              to="/forgot-password"
              className="text-mute hover:text-white gps-mono text-[10px] tracking-[0.25em]"
              data-testid="login-forgot-link"
            >
              FORGOT PASSWORD?
            </Link>
          </div>
        </form>

        <div className="hud-divider my-6" />
        <div className="text-mute text-xs gps-mono text-center">
          NO ACCOUNT? <Link to="/register" className="text-white" data-testid="login-to-register">CALCULATE</Link>
        </div>
      </GlassPanel>
    </div>
  );
}
